module.exports = __webpack_public_path__ + "static/img/info_button4.ba4fd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button4.png
// module id = 1YAR
// module chunks = 4